// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__Rs04v","tagButton":"styles_tagButton___NWyk","icon":"styles_icon__HkTqW","label":"styles_label__KahZN"};